<template>
  <v-layout align-center fill-height justify-center class="not-found">
    <v-container>
      <v-row>
        <v-col align="center" justify="center">
          <h1 class="text-h2 white--text">404</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center" justify="center">
          <h1 class="text-h2 white--text">Stránka nenalezena</h1>
        </v-col>
      </v-row>
      <v-row class="ma-10">
        <v-col align="center" justify="center">
          <v-btn type="submit" color="primary" class="button--text" height="40px" depressed to="/">
            Zpět na úvodní stránku
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>

<style>
.not-found {
  background: #000;
}
</style>
